import type { TourSection } from './types';

export const aiSuggestionsSections: TourSection[] = [
  {
    id: 'inbox',
    label: 'Inbox de sugerencias',
    steps: [
      {
        target: '[data-tour="suggestions-inbox"]',
        title: 'Bandeja de sugerencias',
        content:
          'Acá se acumulan las sugerencias que generó la IA para distintos productos. Cada fila te dice qué atributo, el valor sugerido, cuánto costó generarla y en qué estado está.',
      },
    ],
  },
  {
    id: 'filters',
    label: 'Filtros',
    steps: [
      {
        target: '[data-tour="suggestions-filters"]',
        title: 'Filtros de la bandeja',
        content:
          'Filtra por estado (pendiente, aceptada, rechazada, en proceso, fallida), por SKU de producto, por atributo o por fecha.',
      },
    ],
  },
  {
    id: 'row-actions',
    label: 'Aceptar o rechazar una',
    steps: [
      {
        target: '[data-tour="suggestions-row-actions"]',
        title: 'Acciones por sugerencia',
        content:
          'Cada sugerencia pendiente tiene dos botones: aceptar (✓) aplica el valor al producto, rechazar (✗) la archiva sin cambiar nada.',
      },
    ],
  },
  {
    id: 'bulk-generate',
    label: 'Generar muchas a la vez',
    steps: [
      {
        target: '[data-tour="suggestions-bulk-generate"]',
        title: 'Generar en lote',
        content:
          'Abre un diálogo para generar sugerencias de muchos productos de una sola vez. Antes de enviar te muestra una estimación del costo. Tope: 500 productos por ejecución.',
      },
    ],
  },
  {
    id: 'bulk-actions',
    label: 'Aceptar/rechazar en lote',
    steps: [
      {
        target: '[data-tour="suggestions-bulk-actions"]',
        title: 'Acciones en lote',
        content:
          'Marca varias sugerencias pendientes con las casillas y aplica la misma acción a todas. Útil cuando revisaste visualmente que los valores tienen sentido.',
      },
    ],
  },
];
